document.addEventListener('DOMContentLoaded', function() {
  const modal = document.getElementById('mv-size-guide-modal');
  const triggerBtns = document.querySelectorAll('.mv-size-guide-trigger-btn');
  const closeBtn = document.getElementById('mv-size-guide-close');
  const unitBtns = document.querySelectorAll('.mv-unit-btn');
  const thead = document.getElementById('mv-size-guide-thead');
  const tbody = document.getElementById('mv-size-guide-tbody');

  if (!modal || !triggerBtns.length || !thead || !tbody) return;

  // Expect window.mvSizeGuideData to be populated with Kiwi-like structure
  // It should be an array of sizing objects, we take the first matching one
  let currentUnit = 'cm';
  let sizeData = null;

  if (window.mvSizeGuideData) {
    let rawData = window.mvSizeGuideData;
    if (Array.isArray(rawData) && rawData.length > 0) {
      rawData = rawData[0];
    }
    
    if (rawData && rawData.tables) {
      const tableKeys = Object.keys(rawData.tables);
      if (tableKeys.length > 0) {
        sizeData = rawData.tables[tableKeys[0]];
      }
    }
  }

  if (!sizeData) {
    // Hide trigger button if no data
    triggerBtns.forEach(btn => btn.style.display = 'none');
    return;
  }

  function renderTable(unit) {
    if (!sizeData || !sizeData.data || sizeData.data.length === 0) return;

    thead.innerHTML = '';
    tbody.innerHTML = '';

    const data = sizeData.data;

    // First row is headers
    const headers = data[0];
    const headerRow = document.createElement('tr');
    headers.forEach(h => {
      const th = document.createElement('th');
      th.textContent = h.value || '';
      headerRow.appendChild(th);
    });
    thead.appendChild(headerRow);

    // Remaining rows are data
    for (let i = 1; i < data.length; i++) {
      const row = data[i];
      const tr = document.createElement('tr');
      row.forEach((cell, index) => {
        const td = index === 0 ? document.createElement('th') : document.createElement('td');
        
        let val = parseFloat(cell.value);
        if (!isNaN(val) && cell.value !== '') {
          // Convert if needed
          if (unit === 'cm' && cell.unitType === 'in') {
            val = (val * 2.54).toFixed(1);
          } else if (unit === 'in' && cell.unitType === 'cm') {
            val = (val / 2.54).toFixed(1);
          } else {
            // Keep original precision or convert to string
            val = cell.value;
          }
          td.textContent = val;
        } else {
          td.textContent = cell.value || '';
        }
        
        tr.appendChild(td);
      });
      tbody.appendChild(tr);
    }
  }

  // Initial render
  renderTable(currentUnit);

  triggerBtns.forEach(btn => btn.addEventListener('click', () => {
    modal.style.display = 'flex';
    // Small delay to allow display block to apply before changing opacity for transition
    setTimeout(() => { modal.classList.add('is-visible'); }, 10);
  }));

  closeBtn.addEventListener('click', () => {
    modal.classList.remove('is-visible');
    setTimeout(() => {
      modal.style.display = 'none';
    }, 300); // match transition duration
  });

  // Close on outside click
  modal.addEventListener('click', (e) => {
    if (e.target === modal) {
      closeBtn.click();
    }
  });

  // Unit toggle
  unitBtns.forEach(btn => {
    btn.addEventListener('click', (e) => {
      unitBtns.forEach(b => b.classList.remove('active'));
      const target = e.currentTarget;
      target.classList.add('active');
      currentUnit = target.getAttribute('data-unit');
      renderTable(currentUnit);
    });
  });
});
